angular.module('cpm').config(($routeProvider) => {
    'use strict';
    $routeProvider
        .when('/account/:accountId/:advertiserId/campaign/:campaignId', {
            redirectTo: (params) => `/account/${params.accountId}/${params.advertiserId}/campaign/${params.campaignId}/creatives`
        })

        .when('/account/:accountId/:advertiserId/campaign/:campaignId/feed', {
            templateUrl: 'campaign/feed.html',
            controller: 'CampaignFeedCtrl as feed',
            title: 'Campaign Feed',
            role: 'ADMIN'
        })

        .when('/account/:accountId/:advertiserId/campaign/:campaignId/creatives', {
            templateUrl: 'campaign/creative-templates.html',
            controller: 'CreativeTemplateCtrl',
            title: 'Creatives',
            role: 'ADMIN'
        })

        .when('/account/:accountId/:advertiserId/campaign/:campaignId/creatives/import', {
            templateUrl: 'campaign/import-creative.html',
            controller: 'ImportCreativeCtrl',
            title: 'Import Creatives',
            role: 'ADMIN'
        })

        .when('/account/:accountId/:advertiserId/campaign/:campaignId/creatives/builder', {
            templateUrl: 'builder/builder.html',
            controller: 'BuilderCtrl',
            title: 'Creative Builder',
            role: 'ADMIN'
        })

        .when('/account/:accountId/:advertiserId/campaign/:campaignId/creatives/:creativeId/builder', {
            templateUrl: 'builder/builder.html',
            controller: 'BuilderCtrl',
            title: 'Creative Builder',
            role: 'ADMIN'
        })

                .when('/account/:accountId/:advertiserId/campaign/:campaignId/creatives/:creativeId/import/document', {
            templateUrl: 'builder/builder.html',
            controller: 'BuilderCtrl',
            title: 'Creative Builder',
            role: 'ADMIN'
        })

});
